import { FC } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import '../styles.scss';
import { Alerts } from '@pickit/pickit-components';
import { useTheming } from '../config/theme';
import PublicLayout from './layouts/PublicLayout/PublicLayout';

const App: FC = () => {
  useTheming();
  return (
    <>
      <Router>
        <Switch>
          <Route path="/" component={PublicLayout} />
        </Switch>
      </Router>
      <Alerts />
    </>
  );
};

export default App;
